import { render, staticRenderFns } from "./BrowseArticles.vue?vue&type=template&id=ee08faa2&scoped=true&"
import script from "./BrowseArticles.ts?vue&type=script&lang=ts&"
export * from "./BrowseArticles.ts?vue&type=script&lang=ts&"
import style0 from "./BrowseArticles.vue?vue&type=style&index=0&id=ee08faa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee08faa2",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QIcon,QInput});
